import { mq, StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  scroll: {
    _web: {
      height: "100%",
    },
  },
  container: {
    margin: "auto",
    maxWidth: spacing(160),
    width: "100%",
    paddingHorizontal: {
      xs: spacing(4),
      sm: spacing(6),
    },
  },
  logo: {
    width: spacing(42),
    marginVertical: CustomPlatform.select({
      tv: spacing(8),
      default: spacing(12),
      web: 0,
    }),
    aspectRatio: 4 / 3,
    alignSelf: "center",
    marginBottom: CustomPlatform.select({
      tv: spacing(4),
      default: spacing(12),
    }),
  },
  title: {
    marginBottom: spacing(4),
    paddingHorizontal: spacing(4),
    textAlign: "center",
    maxWidth: "100%",
    marginHorizontal: "auto",
  },
  body: {
    textAlign: "center",
    paddingHorizontal: spacing(2),
    color: colors.foregroundDefault,
    maxWidth: "90%",
    marginHorizontal: "auto",
  },
  actions: {
    maxWidth: spacing(120),
    marginHorizontal: "auto",
    width: "100%",
    marginVertical: spacing(12),
    gap: spacing(4),
    flex: {
      [mq.only.width(undefined, "md")]: 1,
    },
    justifyContent: {
      [mq.only.width(undefined, "md")]: "flex-end",
    },
    paddingHorizontal: {
      [mq.only.width("md")]: CustomPlatform.select({
        tv: spacing(18),
        default: spacing(4),
      }),
    },
  },
  footer: {
    display: CustomPlatform.select({
      tv: "none",
    }),
    paddingHorizontal: spacing(12),
    marginBottom: spacing(4),
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  footerLinks: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: spacing(8),
  },
}));

export default stylesheet;
